import React from 'react';
import { Box, Typography } from '@mui/material';
import { ReactComponent as ExactlyIcon } from '../../assets/exactly-icon.svg';
import { CircleBox } from './StepperCircles.styles';
import { EventFormStep } from '../../common/enums/common.enum';

interface StepperCirclesProps {
  activeStep: EventFormStep;
}

const steps = [
  { step: EventFormStep.GroupAndEventSelectStep, label: 'Basic details' },
  { step: EventFormStep.EventSetupStep, label: 'Events setup' },
  { step: EventFormStep.ReviewStep, label: 'Overview' }
];

const StepperCircles: React.FC<StepperCirclesProps> = ({ activeStep }) => {
  return (
    <Box display="flex" justifyContent="center" mb={5}>
      {steps.map(({ step, label }) => {
        const isActive = step === activeStep;
        const isPrevious = step < activeStep;

        return (
          <Box key={step} display="flex" flexDirection="column" alignItems="center" sx={{ flex: 1 }}>
            <CircleBox circleColor={isPrevious ? '#9747FF' : isActive ? '#3F3273' : '#D8D8D8'}>
              {isPrevious ? <ExactlyIcon /> : <span>{step + 1}</span>}
            </CircleBox>
            <Typography variant="h5" sx={{ fontWeight: isPrevious ? 600 : 400 }}>
              {label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default StepperCircles;
